<template>
    <router-view></router-view>
</template>

<script>
    import FAVICONS from "shared/favicons";

    export default {
        name: "WikiMainRouter",
        metaInfo() {
            return {
                title: 'Wiki',
                titleTemplate: `%s - Multi Me`,
                link: [
                    {rel: 'icon', href: FAVICONS.wiki, type: 'image/x-icon', vmid: 'favicon',},
                    {rel: 'apple-touch-icon', sizes: '180x180', href: FAVICONS.wiki_apple, vmid: 'apple-touch-icon',},
                    {
                        rel: 'apple-touch-icon-precomposed',
                        sizes: '180x180',
                        href: FAVICONS.wiki_apple,
                        vmid: 'apple-touch-icon-precomposed',
                    },
                ],
                meta: [
                    // {name: "apple-mobile-web-app-capable", content: "yes"}
                ]
            };
        }
    };
</script>

<style scoped>

</style>